import React from "react";
import { Spinner } from "react-bootstrap";

const ButtonLoader = () => {
  return <Spinner animation="border" role="status" variant="white" className="button_loader"></Spinner>;
};

export default ButtonLoader;
